import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLinkOutSmall2 = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "-8 -8 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "2.5em",
	height: "2.5em",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.2 12.8L20 4",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6 4H20V10.4",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 4V20H20",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgArrowLinkOutSmall2);
export default ForwardRef;
